import util from '../lib/util';
import newHRTimestamp from '../lib/picos/timestamp';
import type {uuid, SchemaField, EntitySchema} from "../@types/schema";
import Base from "./base";
import {genUUID} from "../lib/picos/uuids";
import type {EntityType} from "../@types/entity";
function getCurrentUserId() { return sessionStorage.getItem('userId'); }
function getCurrentFirmId() { return sessionStorage.getItem('firmId'); }
export const Type = {
    Boolean: "boolean",
    String: "string",
    Numeric: "numeric",
    Array: "array",
    Object: "object"
};
export type TypeType = typeof Type[keyof typeof Type];
class Option extends Base implements EntityType {
    optionId: uuid;
    userScope: boolean;
    type: TypeType;
    label: string;
    value: string;
    constructor(doc: typeof Option | any) {
        super(doc);
        if (!doc) doc = {
            firmId: getCurrentFirmId(),
            addedBy: getCurrentUserId(),
            addedOn: newHRTimestamp(),
            status: "C",
            entityId: null,
            entityType: null,
            optionId: genUUID(),
            type: "string",
            label: null,
            value: null,
        };
        // @ts-ignore
        this.entityId = doc._entityId || doc.entityId || doc.entityid || '00000000-0000-0000-0000-000000000000';
        // @ts-ignore
        this.entityType = doc._entityType || doc.entityType || doc.entitytype || "option";
        // @ts-ignore
        this.optionId = doc._optionId || doc.optionId || doc.optionid || genUUID();
        // @ts-ignore
        this.userScope = util.defaultBoolean([doc.userScope, doc._userScope, doc.userscope, false]);
        // @ts-ignore
        this.type = doc._type || doc.type || "string";
        // @ts-ignore
        this.label = doc._label || doc.label || null;
        // @ts-ignore
        this.value = doc._value || doc.value || null;
    }
    get id(): uuid { return this.optionId; }
    static TYPE_VALUES = ["boolean", "string", "numeric", "array", "object"];
    static override getPkFields(): SchemaField[] { return [{"type":"uuid","required":true,"pk":true,"default":"__UUID__","comment":"Unique ID for the option"},{"type":"uuid","required":true,"pk":true,"base":true,"default":"__FIRM__","mergeStrategy":"immutable","comment":"Associated firm"}]; }
    toLowerCase() { return this.optionId; }
    static override getNonRefArrayFields(): string[] { return []; }
    static override getDefaultEntries(): Option[] {
        return [{"optionId":"402fb688-8722-404d-b2f4-022b6c10cee5","userScope":false,"type":"boolean","label":"enforceActivityType","value":"false","status":"C"},{"optionId":"88d9cd81-505c-4ec2-9d6f-e0a49e697ea7","userScope":false,"type":"boolean","label":"enforceCategorySelected","value":"false","status":"C"},{"optionId":"7c2d2046-c52c-4bd9-b678-361deab868f4","userScope":false,"type":"boolean","label":"enforceTieInsComplete","value":"false","status":"C"},{"optionId":"b8d4d0a9-c62d-4f60-91c5-9cc757b61a45","userScope":false,"type":"boolean","label":"paidConsults","value":"false","status":"C"}].map(e => new Option(e));
    }
    static override getSchema(): EntitySchema {
        return Base.withBaseFields({
    entity: 'option',
    dataArea: 'Firm Settings',
    table: 'OPTION',
    comment: `A key-value configuration setting for the firm or an individual user. Each record stores a named setting (label), its stringified value, and the value's data type (boolean, string, numeric, array, or object). Settings are scoped firm-wide by default; setting userScope to true makes the record private to the user identified by addedBy. Used to control billing rules, invoice formatting, payment portal behavior, lead/consult defaults, and UI preferences.`,
    fields: {
        optionId: {
            type: 'uuid',
            required: true,
            pk: true,
            default: '__UUID__',
            comment: 'Unique ID for the option'
        },
        userScope: {
            type: 'boolean',
            comment: 'Should we use user-level scoping (if so, will use addedBy for scope)'
        },
        type: {
            type: 'string',
            values: ['boolean', 'string', 'numeric', 'array', 'object'],
            required: true,
            default: 'string',
            comment: 'The type of object to store'
        },
        label: {
            type: 'string',
            required: true,
            comment: 'A label for the option'
        },
        value: {
            type: 'string',
            required: true,
            comment: 'The stringified value'
        }
    },
    indexes: [
        {name: 'notStored', fn: o => !o.label?.endsWith('stored')}
    ],
    maps: [
        {name: 'label', keysFn: t => t.label, presentFn: (t, k) => t.label === k}
    ],
    entries: [
        {optionId: '402fb688-8722-404d-b2f4-022b6c10cee5', userScope: false, type: 'boolean', label: 'enforceActivityType', value: 'false'},
        {optionId: '88d9cd81-505c-4ec2-9d6f-e0a49e697ea7', userScope: false, type: 'boolean', label: 'enforceCategorySelected', value: 'false'},
        {optionId: '7c2d2046-c52c-4bd9-b678-361deab868f4', userScope: false, type: 'boolean', label: 'enforceTieInsComplete', value: 'false'},
        {optionId: 'b8d4d0a9-c62d-4f60-91c5-9cc757b61a45', userScope: false, type: 'boolean', label: 'paidConsults', value: 'false'}
    ]
});
    }
}
export default Option;
